import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import NewIcon from '@mui/icons-material/Add';
import dateFormat from 'dateformat';
import { v4 as uuidv4 } from 'uuid';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import TitledSection from '../../common/TitledSection/TitledSection';
import CVBaseItem from '../../common/CVBaseItem/CVBaseItem';
import classes from './scss/historyListPB.module.scss';
import { cvUpdate } from '../../../actions/uploadData';
import AddEditCVRecord from '../../common/ModalWindows/AddEditCVRecord';

function EducationsPB(props) {
  const { forErrors = false } = props;

  const dispatch = useDispatch();
  const [t] = useTranslation();
  const educationsItems = useSelector((state) =>
    !forErrors
      ? state.uploadData.parsedCV.EducationDetails.map((item) => ({
          id: item?.id,
          UniversityName: item?.SchoolName,
          Degree: item?.Degree?.Name,
          FieldOfStudy: item?.Major,
          StartDate: item?.StartDate,
          EndDate: item?.EndDate,
          CurrentlyStudyHere: item?.CurrentlyStudyHere
        }))
      : state.uploadData.validationErrors.EducationDetails?.map((item) => ({
          id: item?.id,
          UniversityName: item?.SchoolName,
          Degree: item?.Degree?.Name,
          FieldOfStudy: item?.Major,
          StartDate: item?.StartDate,
          EndDate: item?.EndDate,
          CurrentlyStudyHere: item?.CurrentlyStudyHere
        }))
  );

  const [openAddWindow, setAddWindow] = React.useState(false);

  const deleteHandler = (id) => {
    dispatch(cvUpdate({ flag: 'EducationDelete', value: id }));
  };

  const addEducation = async (education) => {
    const start = new Date(education.startdate);
    start.setHours(0);
    const end = new Date(education.enddate);
    end.setHours(0);

    dispatch(
      cvUpdate({
        flag: 'EducationAdd',
        value: {
          id: uuidv4(),
          SchoolName: education.school,
          Degree: { Name: education.degree, Type: education.degreetype },
          Major: education.fieldofstudy,
          StartDate: dateFormat(start, 'isoDateTime'),
          EndDate: dateFormat(end, 'isoDateTime'),
          CurrentlyStudyHere: false
        }
      })
    );
    setAddWindow(false);
  };

  const isCurrentMonth = (date) => {
    return dayjs(date).year() === dayjs().year() && dayjs(date).month() === dayjs().month();
  };

  const updateEducation = async (id, education) => {
    const start = new Date(education.startdate);
    start.setHours(0);
    const end = new Date(education.enddate);
    end.setHours(0);

    dispatch(
      cvUpdate({
        flag: 'EducationUpdate',
        value: {
          id,
          SchoolName: education.school,
          Degree: { Name: education.degree, Type: education.degreetype },
          Major: education.fieldofstudy,
          StartDate: dateFormat(start, 'isoDateTime'),
          EndDate: dateFormat(end, 'isoDateTime'),
          CurrentlyStudyHere: isCurrentMonth(education.enddate) ? education.currentlyStudyHere : false
        }
      })
    );
  };

  return (
    <TitledSection
      title={t('profile.builder.details.education')}
      actions={!forErrors && <NewIcon role="button" className={classes.action} onClick={() => setAddWindow(true)} />}
    >
      <hr className={classes.divider} />
      <div className={classes.list}>
        {openAddWindow && (
          <AddEditCVRecord
            withCurrentlyCheckBox={false}
            open
            closeHandler={() => setAddWindow(false)}
            editeMode={false}
            confirmHandler={addEducation}
            block="educations"
            shouldImmediatelySave
          />
        )}
        {educationsItems?.map((item) => (
          <Fragment key={item.id}>
            <CVBaseItem
              withCurrentlyCheckBox={false}
              item={item}
              block="educations"
              deleteItem={() => deleteHandler(item?.id)}
              editItem={(data) => updateEducation(item?.id, data)}
              shouldImmediatelySave
            />
          </Fragment>
        ))}
      </div>
    </TitledSection>
  );
}

export default EducationsPB;
